export default "__VITE_ASSET__Cod7vwgF__"